import { ReactNode } from "react";
import { Icon } from "dash-ui";

interface WarningBannerProps {
  className?: string;
  children?: ReactNode;
}

export function WarningBanner({
  className = "",
  children,
}: WarningBannerProps) {
  return (
    <div
      className={`p-4 rounded-lg border border-amber-200 bg-amber-50 w-full ${className}`}
    >
      <div className="flex items-center justify-center gap-3">
        <Icon
          name="warningOutlined"
          size={20}
          className="flex-shrink-0 text-amber-600"
        />
        <div className="text-sm text-amber-800">{children}</div>
      </div>
    </div>
  );
}
